(ns app.front.view.group.admin.config.form-schema-subs
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.form-schemas.util :as form-schemas-util]
            [app.front.view.group.admin.subs :as gas]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::all-schemas
  (fn [_ _]
    [(rf/subscribe [::gas/group-id])
     (rf/subscribe [::gas/superdomain])
     (rf/subscribe [::entities/entities {:entity/type :entity.type/form-schema}])])
  (fn [[group-id superdomain all-schemas] _]
    (let [visible? #(or (= group-id %)
                        (when (ff/enabled? :feature-flag.id/superdomain-can-manage-forms)
                          (some-> superdomain :db/id (= %))))]
      (->> all-schemas
           (filter #(-> % :domain/authority-group :db/id visible?))
           (map #(cond-> %
                   (-> % :domain/authority-group :db/id (= (:db/id superdomain)))
                   (form-schemas-util/rename-inherited-form-schema superdomain)))
           (sort-by :form.schema/name)))))

(defn signal-all-schemas [_ _]
  (rf/subscribe [::all-schemas]))

(defn filter-schemas [f]
  (fn [all-schemas _]
    (->> all-schemas
         (filter f))))

(defn schema-filter [& expected-schema-types]
  (let [types (set expected-schema-types)]
    (fn [{schema-type :form.schema/type}]
      (contains? types schema-type))))

(rf/reg-sub ::base-schemas
  signal-all-schemas
  (filter-schemas (schema-filter nil
                                 :form.schema.type/general
                                 :form.schema.type/work-specific)))

(rf/reg-sub ::pre-consultation-schemas
  signal-all-schemas
  (filter-schemas (schema-filter :form.schema.type/pre-consultation)))

(rf/reg-sub ::role-schemas
  signal-all-schemas
  (filter-schemas (schema-filter :form.schema.type/role-specific)))

(rf/reg-sub ::sign-off-schemas
  signal-all-schemas
  (filter-schemas (schema-filter :form.schema.type/sign-off)))

(rf/reg-sub ::execution-schemas
  signal-all-schemas
  (filter-schemas (schema-filter :form.schema.type/execution)))

(rf/reg-sub ::periodic-schemas
  signal-all-schemas
  (filter-schemas (schema-filter :form.schema.type/periodic)))
